import {
    Component, ChangeDetectionStrategy,
    Input, AfterContentInit, Output,
    EventEmitter, OnChanges
} from '@angular/core';

@Component({
    selector: 'app-pagination',
    template: require('./pagination.component.html'),
    styles: [require('./pagination.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class PaginationComponent implements AfterContentInit, OnChanges {

    @Input()
    public totalItems: number;

    @Input()
    public currentPage = 1;

    @Input()
    public pageSize = 10;

    @Input()
    public pagePerItems = [10, 50, 100, 200];

    @Output()
    public paginationEvent = new EventEmitter<Pager>();

    public pager: Pager;

    public showAfterDots: boolean;

    public showBeforeDots: boolean;

    public gotoPageItems: number[];

    constructor() {
        
    }

    public ngAfterContentInit(): void {
        // this.getPager();
    }

    public ngOnChanges() {
        this.getPager();
    }

    public getPager() {
        let totalPages = Math.ceil(this.totalItems / this.pageSize);

        if (this.currentPage < 1) {
            this.currentPage = 1;
        } else if (this.currentPage > totalPages) {
            this.currentPage = totalPages;
        }

        let startPage: number;
        let endPage: number;

        if (totalPages <= 5) {
            startPage = 1;
            endPage = totalPages;
            this.showBeforeDots = false;
            this.showAfterDots = false;
        } else {
            if (this.currentPage <= 3) {
                startPage = 1;
                endPage = 5;
                this.showBeforeDots = false;
                this.showAfterDots = true;
            } else if (this.currentPage + 1 >= totalPages) {
                startPage = totalPages - 4;
                endPage = totalPages;
                this.showBeforeDots = true;
                this.showAfterDots = false;
            } else {
                startPage = this.currentPage - 2;
                endPage = this.currentPage + 2;
                this.showBeforeDots = true;
                this.showAfterDots = (endPage !== totalPages);
            }
        }

        let startIndex = (this.currentPage - 1) * this.pageSize;
        let endIndex = Math.min(startIndex + this.pageSize - 1, this.totalItems - 1);

        let pages = Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);
        this.gotoPageItems = Array.from(Array(totalPages).keys()).map(i => 1 + i);

        this.pager = {
            totalItems: this.totalItems,
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            visiblePages: pages,
            gotoPages: this.gotoPageItems
        };
    }

    public setPage(selectedValue: number) {
        this.currentPage = +selectedValue;
        this.onPaginationAction();
    }

    public onPagePerItemSelect(selectedValue: number) {
        this.pageSize = +selectedValue;
        this.onPaginationAction();
    }

    public onAfterDotsclick() {
        this.currentPage = this.currentPage + 2;
        this.onPaginationAction();
    }

    public onBeforeDotsclick() {
        this.currentPage = this.currentPage - 2;
        this.onPaginationAction();
    }

    private onPaginationAction() {
        this.getPager();
        this.paginationEvent.emit(this.pager);
    }
}

export interface Pager {
    totalItems: number;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    startPage: number;
    endPage: number;
    startIndex: number;
    endIndex: number;
    visiblePages: number[];
    gotoPages: number[];
}